/** Training API endpoints, merged into the platform API client. */
export const trainingApiEndpoints: Record<string, string> = {
  computes: "/ext/training/computes/",
  createCompute: "POST:/ext/training/computes/",
  compute: "/ext/training/computes/:pk/",
  updateCompute: "PUT:/ext/training/computes/:pk/",
  deleteCompute: "DELETE:/ext/training/computes/:pk/",
  checkCompute: "POST:/ext/training/computes/:pk/check/",
  serverGuide: "/ext/training/computes/guide/",
  cloudCompute: "/ext/training/computes/cloud/",
  connectCloudCompute: "POST:/ext/training/computes/cloud/",
  platformComputes: "/ext/training/platform/computes/",
  createPlatformCompute: "POST:/ext/training/platform/computes/",
  updatePlatformCompute: "PUT:/ext/training/platform/computes/:pk/",
  deletePlatformCompute: "DELETE:/ext/training/platform/computes/:pk/",
  platformComputeUsage: "/ext/training/platform/computes/:pk/usage/",
  allowance: "/ext/training/computes/allowance/",
  askAllowance: "POST:/ext/training/computes/allowance/",
  platformAllowances: "/ext/training/platform/computes/allowances/",
  setPlatformAllowance: "PUT:/ext/training/platform/computes/allowances/",
  recipes: "/ext/training/recipes/",
  createRecipe: "POST:/ext/training/recipes/",
  updateRecipe: "PUT:/ext/training/recipes/:pk/",
  deleteRecipe: "DELETE:/ext/training/recipes/:pk/",
  projectTraining: "/ext/training/projects/:pk/",
  saveProjectTraining: "PUT:/ext/training/projects/:pk/",
  freezeBenchmark: "POST:/ext/training/projects/:pk/benchmark/",
  retireBenchmark: "DELETE:/ext/training/projects/:pk/benchmark/",
  startTrainingRun: "POST:/ext/training/projects/:pk/runs/",
  trainingRunAction: "POST:/ext/training/projects/:pk/runs/:run/",
  trainingRunCard: "/ext/training/projects/:pk/runs/:run/card/",
};
